import { SvgIcon } from "@mui/material";

function Icon({ color, ...props }) {
  return (
    <SvgIcon {...props} fontSize="small" viewBox="0 0 20 16">
      <path
        d="M3 0C1.343 0 0 1.3431 0 3V13C0 15 1 16 3 16H17C19 16 20 15 20 13V5C20 4.4477 19.552 4 19 4H18V1C18 0.4477 17.552 0 17 0H3ZM3 2H16V4H3C2.448 4 2 3.5523 2 3C2 2.4477 2.448 2 3 2ZM15 8C15.552 8 16 8.4477 16 9C16 9.5523 15.552 10 15 10C14.448 10 14 9.5523 14 9C14 8.4477 14.448 8 15 8Z"
        fill={color}
      />
    </SvgIcon>
  );
}

export default Icon;
